module.exports = __webpack_public_path__ + "static/why-hassle.aafbe2c5.jpg";